module.exports = __webpack_public_path__ + "static/media/FENGYUN 3D.f99f2748.czml";